import { Toast } from 'antd-mobile';
import query from 'query-string';
import config from '../config/app-config';

export default {
  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
    // const reg = new RegExp(`(^|&?)${name}=([^&]*)(&|$)`, 'i');
    // const r = window.location.href.substr(1).match(reg);
    // if (r != null) return decodeURI(r[2]);
    // return null;
  },

  getQueryExceptString(name) {
    const reg = new RegExp(`(^|&E#?)${name}=([^&]*)(&|$)`, 'i');
    const r = window.location.href.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  },

  // 时间戳解析
  formatUnixtimestamp(unixtimestampData) {
    const unixtimestamp = new Date(unixtimestampData);
    const year = 1900 + unixtimestamp.getYear();
    const month = `0${unixtimestamp.getMonth() + 1}`;
    const date = `0${unixtimestamp.getDate()}`;
    const hour = `0${unixtimestamp.getHours()}`;
    const minute = `0${unixtimestamp.getMinutes()}`;
    return (
      `${year
      }-${
        month.substring(month.length - 2, month.length)
      }-${
        date.substring(date.length - 2, date.length)
      } ${
        hour.substring(hour.length - 2, hour.length)
      }:${
        minute.substring(minute.length - 2, minute.length)}`
    );
  },

  checkPhone(phone) {
    return /^1[3456789]\d{9}$/.test(phone);
  },

  isWeixinCient() {
    return navigator.userAgent.toLowerCase().match(/micromessenger/i)?.[0] === 'micromessenger';
  },

  toWxth(appId) {
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
      window.location.href,
    )}&response_type=code&scope=snsapi_base&source_type=wx&state=3#wechat_redirect`;
  },

  // 微信静默授权
  toSnsapiBaseWxth(appId) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.remove = function a(from) {
      this.length = from < 0 ? this.length + from : from;
      return this;
    };
    let url;
    const wechatRedirect = window.location.href.split('&');
    if (wechatRedirect.length > 1) {
      url = wechatRedirect.remove(-2, -1).join('&');
    } else {
      url = window.location.href;
    }

    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
      url,
    )}&response_type=code&scope=snsapi_base&source_type=wx&state=3#wechat_redirect`;
  },

  debounce(action, delay = 300) {
    let timer = null;
    return function a(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        action.apply(this, args);
      }, delay);
    };
  },

  getTimeDifference(endTime, startTime) {
    if (!startTime || !endTime) {
      return {};
    }

    const start = new Date(startTime).getTime();
    const end = new Date(endTime).getTime();
    if (!start || !end) {
      return {};
    }
    const different = end - start;
    const day = parseInt(different / (24 * 60 * 60 * 1000), 10);
    const hour = parseInt((different % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000), 10);
    const min = parseInt((different % (60 * 60 * 1000)) / (60 * 1000), 10);
    return { day, hour, min };
  },

  catchResultHandle(result) {
    const { code, message, data } = result;

    if (code !== 10000) {
      Toast.show(message, 0.8);
      if (code === 20002) window.location.href = `${config.basePath}/logistics`;
      return Promise.reject(result);
    }
    return data;
  },

  regYuanToFen(yuan, digit) {
    let m = 0;
    const s1 = yuan.toString();
    const s2 = digit.toString();
    try {
      m += s1.split('.')[1].length;
    } catch (e) {
      // console.log(e);
    }
    try {
      m += s2.split('.')[1].length;
    } catch (e) {
      // console.log(e);
    }
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / (10 ** m);
  },

  // 获取钱的单位  已元为单位 传入一个 分为单位的钱
  getMoney(m) {
    let n = m;
    n = n || 0;
    n = String(n);
    const r = n.length - 3;
    if (r < 0) {
      n = Array.from(Array(Math.abs(r))).reduce((pre) => `${pre}0`, '') + m;
    }

    n = n.split('');
    n.splice(n.length - 2, 0, '.');
    n = n.join('');

    return n;
  },
};

/**
 * 判断是不是 ios
 * @returns {boolean}
 */
export const isIOS = () => !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

/**
 * ios 分享刷新页面
 * @returns {boolean}
 */
export const refreshWeb = (history) => {
  if (!isIOS()) return false; // 如果不是是ios 不需要刷新

  const { timeRefreshIos } = query.parse(window.location.search) || {};

  if (timeRefreshIos && new Date().getTime() - Number(timeRefreshIos) < 10000) {
    return false;
  }
  // 如果时间戳存在 并且 在十秒以内，不刷新

  const timestamp = new Date().getTime();
  const oldHref = window.location.pathname;
  let newHref = '';
  const newString = `timeRefreshIos=${timestamp}`;

  if (!timeRefreshIos && !window.location.search) newHref = `${oldHref}?${newString}`; // 如果参数和搜索都不存在
  if (window.location.search && timeRefreshIos) newHref = oldHref.replace(/timeRefreshIos=[^&\s]*/g, newString);
  if (window.location.search && !timeRefreshIos) newHref = `${oldHref}&${newString}`;

  const newReg = new RegExp(config.basePath);
  history.replace(newHref.replace(newReg, ''));
  return true;
};
